angular.module('qkr').factory('productService', function($http, appConfig, $q, imageService) {
    const self = this;

	return {
        currentOutletId: null,
        currentDepartmentId: null,
        currentMenuId: null,
        currentCategoryId: null,
        productList: [],
        categoryList: [],
        editingProduct: null,

        loadProducts(outletId, departmentId, menuId, categoryId) {
            if (outletId != self.currentOutletId || departmentId != self.currentDepartmentId ||
                menuId != self.currentMenuId || categoryId != self.currentCategoryId || self.productList.length == 0) {
                self.currentCategoryId = categoryId;
                self.currentDepartmentId = departmentId;
                self.currentMenuId = menuId;
                self.currentOutletId = outletId;

              return $http.get(appConfig.apiUrl + 'productCategory/' + categoryId + '/products/', {withCredentials: true}).then((response) => {
                    self.productList = response.data;
                    // Set up the full url for each product image (this may change in future)
                    angular.forEach(self.productList, (prod) => {
                      prod.fullImageUrl = imageService.fullImageUrl(prod.imageUrl);
                    });

                    return self.productList;
                });
            } else {
               // Use the cached list

                const deferred = $q.defer();
                deferred.resolve(self.productList);
                return deferred.promise;
            }
        },

        setNewProduct(product, outletId, departmentId, menuId, categoryId) {
            this.editingProduct = product;
            self.currentCategoryId = categoryId;
            self.currentDepartmentId = departmentId;
            self.currentMenuId = menuId;
            self.currentOutletId = outletId;
        },
        setEditingProduct(product, outletId, departmentId, menuId, categoryId) {
            this.editingProduct = product;
            self.currentCategoryId = categoryId;
            self.currentDepartmentId = departmentId;
            self.currentMenuId = menuId;
            self.currentOutletId = outletId;
        },

        updateProduct(p) {
            return $http.post(appConfig.apiUrl + 'product/update', p);
        },
        createProduct(prod, prodGroup) {
            const createCommand = {product: prod, prodGroup};

            return $http.post(appConfig.apiUrl + 'product/create', createCommand);
        }

    };
});




// WEBPACK FOOTER //
// ./src/services/product.services.js